module.exports = __webpack_public_path__ + "static/media/3-9.76205828.mp3";